/**
 *
 * @module contentManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class ContentManagerConfiguration
 * @desc Provides configuration information necessary for managing content data.
 *
 */
export default class ContentManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/contentManagerConfiguration.js